import { createSlice, current, PayloadAction } from '@reduxjs/toolkit'
import { Session } from '@supabase/supabase-js'

export interface UserState {
  session: Session | null
  activeOrganization: number | null
  // TODO: create an interface for params that all slices have
  isProcessing: boolean
  error: any
  errors: any
}

type HandleSessionPayload = Session | null
type ActivateOrganizationPayload = number

const initialState: UserState = {
  session: null,
  activeOrganization: null,

  // Other
  isProcessing: false,

  error: null,
  errors: {},
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    handleSession: (state, { payload }: PayloadAction<HandleSessionPayload>) => {
      state.session = payload
    },
    activateOrganization: (state, { payload }: PayloadAction<ActivateOrganizationPayload>) => {
      state.activeOrganization = payload
    },
  },
  // TODO: Add extra reducers
  extraReducers: (builder) => {},
})

// Action creators are generated for each case reducer function
export const { handleSession, activateOrganization } = userSlice.actions

export default userSlice.reducer
